import {type} from 'arktype'

const ResponseData = type({
  code: 'string',
  msg: 'string?',
  data: 'unknown?',
})
export default ResponseData
export type ResponseData = typeof ResponseData.infer

export const responseData = type('<t>', {
  '...': ResponseData,
  'data': 't',
})

export const paginatedResponseData = type('<t>', {
  '...': ResponseData,
  'data': {
    records: 't[]',
    total: 'number',
    pageSize: 'number',
    page: 'number',
  },
})
